module.exports = __webpack_public_path__ + "img/footer_icon_twitter.47215108.svg";